/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// --- SISTEMA DE FAVORITOS PERSONALIZADO B2BFLIX ---
document.addEventListener('DOMContentLoaded', function() {
  const wishlistBtn = document.getElementById('btn-wishlist');
  if (!wishlistBtn) return;

  const productId = wishlistBtn.getAttribute('data-product-id');
  const wishlistText = document.getElementById('wishlist-text');
  const wishlistIcon = wishlistBtn.querySelector('.wishlist-icon');

  // Obtener favoritos existentes o crear lista vacía
  let wishlist = JSON.parse(localStorage.getItem('b2bflix_wishlist')) || [];

  // Comprobar estado inicial del botón al cargar la página
  if (wishlist.includes(productId)) {
    if (wishlistText) wishlistText.innerText = "Quitar de favoritos";
    if (wishlistIcon) wishlistIcon.innerText = "❤️";
  } else {
    if (wishlistIcon) wishlistIcon.innerText = "🤍"; // Corazón vacío si no está guardado
  }

  // Evento de clic en el botón
  wishlistBtn.addEventListener('click', function(e) {
    e.preventDefault();
    wishlist = JSON.parse(localStorage.getItem('b2bflix_wishlist')) || [];
    
    if (wishlist.includes(productId)) {
      // Si ya está guardado, lo eliminamos
      wishlist = wishlist.filter(id => id !== productId);
      if (wishlistText) wishlistText.innerText = "Añadir a favoritos";
      if (wishlistIcon) wishlistIcon.innerText = "🤍";
    } else {
      // Si no está guardado, lo añadimos
      wishlist.push(productId);
      if (wishlistText) wishlistText.innerText = "Quitar de favoritos";
      if (wishlistIcon) wishlistIcon.innerText = "❤️";
    }
    
    // Guardar lista en el navegador del cliente
    localStorage.setItem('b2bflix_wishlist', JSON.stringify(wishlist));
  });
});
